var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { meResponseDecoder } from "~/client/decoders/meResponse";
import { throwAPIError } from "~/client/errors";
import { QUERY_KEY_PREFIX as GET_ME_QUERY_KEY_PREFIX } from "~/client/hooks/api/useGetMe";
import useSafelyParseJsonResponse from "~/client/hooks/useSafelyParseJsonResponse";
import fetch from "~/client/utils/fetch";
const useCreateMe = () => {
    const queryClient = useQueryClient();
    const parseJson = useSafelyParseJsonResponse();
    return useMutation({
        mutationFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch("/me", {
                method: "POST",
            });
            if (!response.ok) {
                yield throwAPIError(response);
            }
            const responseJson = yield parseJson(response);
            return meResponseDecoder.verify(responseJson);
        }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [GET_ME_QUERY_KEY_PREFIX] });
        },
    });
};
export default useCreateMe;
